module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/Artist-logo.0fb02f8a.png";